import { css, type Theme } from "@emotion/react";

export const BannerContainer = (theme: Theme) => css`
  position: fixed;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  border-radius: 0.5rem;
  padding: 2rem;
  background-color: ${theme.surface.overlayModal};
  bottom: 1rem;
  margin-right: 2rem;
  max-width: 80rem;
  z-index: 9999;
  box-shadow: 0 0.5rem 2rem 0 rgba(54, 72, 92, 0.24);
`;

export const UnAuthContainer = css`
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
`;

export const SmallMargin = css`
  margin-right: 1rem;
`;
